import Types from './types';
import { createReducer } from 'reduxsauce';
import { EXPLORE_TABS } from '../../constants/app-constants';

const INITIAL_STATE = {
    total: 0,
    type: EXPLORE_TABS.map(tab => tab.value),
    results: [],
    isLoading: false,
    isSearchResults: false
};
const auctionRequest = (state = INITIAL_STATE) => {
    return {
        ...state,
        isLoading: true
    };
};
const auctionResponse = (state = INITIAL_STATE) => {
    return {
        ...state,
        isLoading: false
    };
};
const setAuctions = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        ...data,
        isLoading: false
    };
};

const setSearchFlag = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        isSearchResults: data
    };
};
const setAuctionType = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        type: data
    };
};

const HANDLERS = {
    [Types.AUCTION_REQUEST]: auctionRequest,
    [Types.AUCTION_RESPONSE]: auctionResponse,
    [Types.SET_AUCTIONS]: setAuctions,
    [Types.SET_SEARCH_FLAG]: setSearchFlag,
    [Types.SET_AUCTION_TYPE]: setAuctionType
};

export default createReducer(INITIAL_STATE, HANDLERS);